import { render, staticRenderFns } from "./cooperation-contract-index.vue?vue&type=template&id=7afdf0c3&scoped=true&"
import script from "./cooperation-contract-index.vue?vue&type=script&lang=js&"
export * from "./cooperation-contract-index.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-contract-index.vue?vue&type=style&index=0&id=7afdf0c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afdf0c3",
  null
  
)

export default component.exports